export default __webpack_public_path__ + "images/AlertIcon1.svg";